export const internalConstants = {
  BACK: 'BACK',
  FORWARD: 'FORWARD',
  BRIEF: 'brief',
  BACKMATTER: 'backmatter',
  START: 'start',
  ENTRY: 'entry',
};
